import { render, staticRenderFns } from "./Mostgames.vue?vue&type=template&id=91b07940&scoped=true"
import script from "./Mostgames.vue?vue&type=script&lang=js"
export * from "./Mostgames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b07940",
  null
  
)

export default component.exports